<template>
  <div v-if="visible" class="cookie-notification">
    <p class="cookie-notification__text">
      This website uses cookies to ensure you get the best experience on our
      website.
    </p>
    <div class="cookie-notification__actions">
      <NuxtLink :to="{ name: 'privacy' }">More information</NuxtLink>
      <Button icon="iconoir-cookie" @click.prevent="hide()"> Got it </Button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCookie } from '#app'

const cookieName = 'cookieConsent'
const visible = ref(false)

// Cookie with 1 year expiration
const cookieConsent = useCookie(cookieName, {
  maxAge: 60 * 60 * 24 * 365, // 1 year in seconds
  path: '/',
})

onMounted(() => {
  if (cookieConsent.value === undefined || cookieConsent.value === null) {
    visible.value = true
  }
})

function hide() {
  cookieConsent.value = new Date().getTime()
  visible.value = false
}
</script>
